import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import style from "../assets/css/page/FreePlayers.module.css";
import LogoHeader from "../components/Header/LogoHeader";
import Loading from "../components/Loading";
import Modal from "../components/Modal";
import { socket } from "../config/socket";
import useUpdatePlayer from "../hooks/useUpdatePlayer";

const modalStates = { addPlayerFree: false };

function FreePlayers() {
  const [players, setPlayers] = useState([]);
  const [playerSelect, setPlayerSelect] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPlayers, setTotalPlayers] = useState(0);
  const [activeModals, setActiveModals] = useState(modalStates);
  const { updatePlayer } = useUpdatePlayer();
  const role = window.localStorage.getItem("role");
  const team = JSON.parse(window.localStorage.getItem("team"));

  useEffect(() => {
    setLoading(true);
    let idTeam = team?.id;

    if (idTeam) {
      socket.emit("totalPlayer", { idTeam }, (res) => {
        setTotalPlayers(res);
      });
    }

    socket.emit("freePlayers", (res) => {
      setLoading(false);
      setPlayers([res]);
    });
  }, []);

  const changeModalState = (modal, player) => async () => {
    setPlayerSelect(player);
    setActiveModals({ ...activeModals, [modal]: !activeModals[modal] });
  };

  const PlayerToTeam = async (player) => {
    setLoading(true);
    let idTeam = team?.id;

    const response = await updatePlayer(player, {
      team: idTeam,
    });
    if (response?.id) {
      setActiveModals({
        ...activeModals,
        addPlayerFree: !activeModals["addPlayerFree"],
      });

      socket.emit("totalPlayer", { idTeam }, (res) => {
        setTotalPlayers(res);
      });

      socket.emit("freePlayers", (res) => {
        setLoading(false);
        setPlayers([res]);
      });
      // window.location.reload();
    }
  };

  if (loading) return <Loading />;

  return (
    <div className={style.container}>
      <div className={style.header}>
        <LogoHeader />
      </div>
      <div className={style.contTable}>
        <table className={style.table}>
          <thead className={style.headTable}>
            <tr className={style.row}>
              <td className={style.column}>Nombre</td>
              <td className={style.column}>Posición</td>
              <td className={style.column}>Jugados</td>
              <td className={style.column}>Goles</td>
              <td className={style.column}>Amarillas</td>
              <td className={style.column}>Rojas</td>
              <td className={style.column}></td>
            </tr>
          </thead>
          <tbody className={style.bodyTable}>
            {players[0]?.map((player, index) => (
              <RowData
                key={index}
                player={player}
                openModal={changeModalState("addPlayerFree", player)}
                totalPlayers={totalPlayers}
                role={role}
                teamLogin={team}
              />
            ))}
          </tbody>
        </table>
      </div>
      <Modal
        title={`Vincular jugador a ${team?.name}`}
        show={activeModals.addPlayerFree}
        close={changeModalState("addPlayerFree")}
      >
        <AceptPlayer data={playerSelect} saveToTeam={PlayerToTeam} />
      </Modal>
    </div>
  );
}

const RowData = ({ player, openModal, totalPlayers, role, teamLogin }) => (
  <tr className={style.row}>
    <td
      className={style.data}
    >{`${player.name} ${player.app} ${player.apm}`}</td>
    <td className={style.data}>
      <p className={classNames(style.position, style[player.position])}>
        {player.position}
      </p>
    </td>
    <td className={style.data}>{player.played}</td>
    <td className={style.data}>{player.goal}</td>
    <td className={style.data}>{player.yellowCard}</td>
    <td className={style.data}>{player.redCard}</td>
    <td className={style.data}>
      {role === "leader" && totalPlayers < 15 ? (
        <button className={style.btnAdd} onClick={openModal}>
          <span className={style.icon}>
            <FontAwesomeIcon icon={faPlus} />
          </span>
          Mi equipo
        </button>
      ) : (
        "-- N/S --"
      )}
    </td>
  </tr>
);

const AceptPlayer = ({ data, saveToTeam }) => {
  return (
    <div className={style.contFreePlayer}>
      <p className={style.text}>¿Seguro que quieres agregar a este jugador?</p>
      <p className={style.name}>{`${data?.name} ${data?.app} ${data?.apm}`}</p>
      <button className={style.btnAdd} onClick={() => saveToTeam(data.id)}>
        Si, aceptar
      </button>
    </div>
  );
};

export default FreePlayers;
